import NavigationPanel from "../navigation-panel";
import NavigationSection from "../../../core/model2/navigation/navigation-section";

// const debug = "navigation_clickSectionWhenMenuPopover"
const debug = false

export default async function navigation_clickSectionWhenMenuPopover(navigationPanel: NavigationPanel, section: NavigationSection, resolve:callback, reject:callback) {

    debug && console.brown(debug)

    // Minimized states
    const isMenuOpen = gd.layout.isMenuPopoverShown

    if (section.id === navigationPanel.state.currentSection?.id) {  // yes by id
        debug && console.log(debug, "Same Section click isMenuPopoverShown=", gd.layout.isMenuPopoverShown)

        if (gd.layout.isMenuPopoverShown) {
            debug && console.log(debug, "menu open - just closed it please")

            gd.layout.mainMenuStatic?.hide()
            // await gd.layout.mainMenuPopover?.hidePopover("navigation_clickSectionWhenMenuPopover -1 ")
            resolve(true)
            return
        } else {
            debug && console.log(debug, "menu closed - open menu")

            if (!section.menuComponent) {
                // do nothing
                debug && console.log(debug, "no menu for this item - skip")
                resolve(true)
                return
            }

            // await gd.layout.mainMenuPopover?.showPopover()
            gd.layout.mainMenuStatic?.show()
            resolve(true)
            return
        }
    }

    // different section clicked...
    await navigationPanel.setCurrentSection(section)

    debug && console.log("navigation render done -> process menu")

    // IF no menu
    if (!section.menuComponent) {
        debug && console.log(debug, "Current Section has no menu")
        if (isMenuOpen) {
            debug && console.log(debug, "Previous Section has open menu -> close it")
            await gd.layout.currentMenu?.hide()
            // await gd.layout.mainMenuPopover?.hidePopover("navigation_clickSectionWhenMenuPopover - 2")
        }
        resolve(true)
        return
    }

    // IF menu
    if (gd.layout.currentMenu) {
        await gd.layout.currentMenu?.reRender()
        // console.log("mainMenuPopover - render done")
    } else {
        console.error("#LAYOUT-651 no menu component found")
    }

    gd.layout.mainMenuStatic?.show()

    resolve(true)
    return

}
